<template>
 <div>
    <loader :show="enviando"/>
    <b-modal  v-model="mostrar" size="xl" title="Agregar escolaridad" hide-footer  hide-header-close no-close-on-backdrop>   
    <b-card-body>
    <b-row>
      <b-col md="3">
        <b-form-group label="UBICACIÓN">
          <b-form-select           
            @change="cambios=true"
            v-model="estudio.institucionEducativa.ubicacion"
            :options="pais"
            text-field="valor"
            value-field="clave"
            >
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group label="NIVEL">
          <b-form-select    
            v-model="estudio.nivel.clave"
            :options="nivel"
            text-field="valor"
            value-field="clave"
            @change="seleccionaValor(), cambios=true"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <label >INSTITUCIÓN EDUCATIVA</label>
          <b-form-input
            @change="cambios=true"
            v-model="estudio.institucionEducativa.nombre"
            placeholder="NOMBRE DE LA INSTITUCIÓN"
            :class="{invalid_input: $v.estudio.institucionEducativa.nombre.$error}"
          ></b-form-input>
          <label v-if="$v.estudio.institucionEducativa.nombre.$error && !$v.estudio.institucionEducativa.nombre.required" class="error-text" ><i>Campo requerido.</i></label>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <label >CARRERA O ÁREA DE CONOCIMIENTO</label >
          <b-form-input
            @change="cambios=true"
            v-model="estudio.carreraAreaConocimiento"
            placeholder="CARRERA"
            :class="{invalid_input: $v.estudio.carreraAreaConocimiento.$error}"
          ></b-form-input>
          <label v-if="$v.estudio.carreraAreaConocimiento.$error && !$v.estudio.carreraAreaConocimiento.required" class="error-text" ><i>Campo requerido.</i></label>
        </b-form-group>
      </b-col>

      <b-col md="2">
        <b-form-group label="ESTATUS">
          <b-form-select
            @change="cambios=true"
            v-model="estudio.estatus"
            :options="opcionStatus"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col md="2">
        <b-form-group label="DOCUMENTO OBTENIDO ">
          <b-form-select
            @change="cambios=true"
            v-model="estudio.documentoObtenido"
            :options="documento"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col md="2">
        <b-form-group label="FECHA OBTENCIÓN ">
        <datetime
          :input-class="'form-control input'"
          v-model="estudio.fechaObtencion"
          type="date"
          @change="cambios=true"
          :class="{invalid_input: $v.estudio.fechaObtencion.$error}"
          >
          </datetime>
           <label v-if="$v.estudio.fechaObtencion.$error && !$v.estudio.fechaObtencion.required" class="error-text" ><i>Campo requerido.</i></label>
        </b-form-group>
      </b-col>

      <b-col md="12">
        <b-row style="text-align: center">
         <b-col>
            <b-button variant="danger" size="sm"  @click="$emit('cancelar')" >CANCELAR</b-button>
          </b-col>
          <b-col>
          <b-button variant="primary" size="sm" @click="guardarEscolaridad(estudio)">GUARDAR</b-button>
          <p v-if="cambios" class="error-text"><i>No se han guardado los cambios</i> </p>
          </b-col> 
        </b-row>
      </b-col>
      </b-row>
       
    
   
    </b-card-body>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import Loader from "../../../views/Loader";
import { mapGetters } from "vuex";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import { required } from "vuelidate/lib/validators";

export default {
  name:"gregarEscolaridad",
  components: { Loader, Datetime,  },
  props: ["mostrar"],
  computed: {
    ...mapGetters(["httpURL", "sessionToken"])
  },
  validations:{
    estudio:{
      institucionEducativa:{nombre:{required}},
      carreraAreaConocimiento: {required},
      fechaObtencion:{required}
    }
  },
  data: function() {
    return {
      enviando: false,
      cambios: false,
      estudio:{        
        nivel: { clave: null, valor: null },
        institucionEducativa: { nombre: null, ubicacion: 'MX' },
        carreraAreaConocimiento: null,
        estatus:null,
        documentoObtenido: null,
        fechaObtencion:null
      },
      nivel: [
        { clave: "PRI", valor: "PRIMARIA" },
        { clave: "SEC", valor: "SECUNDARIA" },
        { clave: "BCH", valor: "BACHILLERATO" },
        { clave: "CTC", valor: "CARRERA TÉCNICA O COMERCIAL" },
        { clave: "LIC", valor: "LICENCIATURA" },
        { clave: "ESP", valor: "ESPECIALIDAD" },
        { clave: "MAE", valor: "MAESTRÍA" },
        { clave: "DOC", valor: "DOCTORADO" }
      ],
      pais: [
        { clave: "MX", valor: "MÉXICO" },
        { clave: "EX", valor: "EXTRANJERO" }
      ],
      opcionStatus: ["CURSANDO", "FINALIZADO", "TRUNCO "],
      documento: ["BOLETA", "CERTIFICADO", "CONSTANCIA", "TITULO"],
 
    };
  },
  methods: {
   
    seleccionaValor() {
      let indice = this.nivel.findIndex(x => x.clave == this.estudio.nivel.clave);
      this.estudio.nivel.valor = this.nivel[indice].valor;
    },
    guardarEscolaridad(estudio) {
      this.$v.$touch();  
      if (!this.$v.$invalid) {
        this.enviando = true;
        axios.post(this.httpURL +"/declaraciones/V2/datosCurricularesDeclarante/" +this.$route.params.id + "/escolaridad",
            {              
              nivelClave: estudio.nivel.clave,
              nivelValor: estudio.nivel.valor,
              institucionEducativaNombre: estudio.institucionEducativa.nombre,
              institucionEducativaUbicacion: estudio.institucionEducativa.ubicacion,
              carreraAreaConocimiento: estudio.carreraAreaConocimiento,
              estatus: estudio.estatus,
              documentoObtenido: estudio.documentoObtenido,
              fechaObtencion: estudio.fechaObtencion
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
            this.enviando = false;
            if (res.data.ok) {   
              this.$notify({    group: "foo",type: "success",  duration: 2500, speed: 1000, text: res.data.mensaje })
              this.cambios = false;
              this.$emit('escolaridadAgregada', res.data.escolaridad)
            }
          })
          .catch(error => {
            this.$notify({  group: "foo",  type: "error",duration: 2500, speed: 1000,  text: "No se pudo guardar la sección."     });
            this.enviando = false;
          });
      }
    
    },
  
    
  },

  created() {
     this.estudio.nivel.clave=this.nivel[0].clave;
     this.estudio.nivel.valor=this.nivel[0].valor;
     this.estudio.estatus=this.opcionStatus[0] ,
     this.estudio.documentoObtenido = this.documento[0]
  }
};
</script>

<style>
.customHr {
  width: 100%;
  font-size: 1px;
  color: rgba(0, 0, 0, 0);
  line-height: 1px;

  background-color: grey;
  margin-top: 0px;
  margin-bottom: 10px;
}
.error-texr {
  color: #ff0000;
}
</style>
